import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LandingPage } from '@/pages/LandingPage';
import PaymentPage from '@/pages/PaymentPage';
import { ProcessingPage } from '@/pages/ProcessingPage';
import { ResultsPage } from '@/pages/ResultsPage';

export const BatchApp: React.FC = () => {
  return (
    <div className="BatchApp">
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="auth" element={<Navigate to="/auth" replace />} />
        <Route path="payment" element={<PaymentPage />} />
        <Route path="processing/:jobId" element={<ProcessingPage />} />
        <Route path="results/:jobId" element={<ResultsPage />} />
        <Route path="results" element={<ResultsPage />} />
        <Route path="*" element={<Navigate to="/batch" replace />} />
      </Routes>
    </div>
  );
};

export default BatchApp;

